import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import { accessories } from '../data/hvacProducts';
import './Accessories.css';

const Accessories: React.FC = () => {
  return (
    <div className="accessories-page">
      <Hero
        title="Installation Accessories"
        subtitle="Professional-grade mounting, refrigeration, and finishing accessories for every TCL HVAC installation."
        background="gradient-slate"
        fullHeight={false}
      />

      <section className="section section--dark">
        <div className="container">
          <div className="accessories-page__grid">
            {accessories.map((acc) => (
              <div key={acc.id} className="accessories-page__card">
                <div className="accessories-page__card-icon">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.6">
                    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
                  </svg>
                </div>
                <span className="accessories-page__card-category">{acc.category}</span>
                <h3 className="accessories-page__card-title">{acc.name}</h3>
                <p className="accessories-page__card-desc">{acc.description}</p>
                <div className="accessories-page__specs">
                  {acc.specs.map((s) => (
                    <div key={s.label} className="accessories-page__spec-row">
                      <span>{s.label}</span>
                      <span>{s.value}</span>
                    </div>
                  ))}
                </div>
                <Link to="/contact" className="btn btn--outline-teal btn--sm">
                  Request Pricing
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--charcoal">
        <div className="container text-center">
          <h2 className="section__title">Need Custom Accessories?</h2>
          <p className="section__subtitle">
            We can source specialty items and custom lengths. Contact us with your project requirements.
          </p>
          <Link to="/contact" className="btn btn--primary btn--lg">Contact Us</Link>
        </div>
      </section>
    </div>
  );
};

export default Accessories;
